<div class="app-container">
  <page-header [icon]="'far-cube'" [title]="'products'" id="pom">
    <ng-container class="header-button">
      <btn
        *ngIf="canCreate"
        [routerLink]="['/product']"
        [label]="'product.create'"
        [title]="'product.create' | translate"
        [classes]="['btn-first', 'float-right']"
        [icon]="'far-plus'"
        data-cy="add-product"
      ></btn>
      <app-exports [entity]="'hs-products'" data-cy="exports"></app-exports>
      <btn
        [routerLink]="['/inventory-exports']"
        [classes]="['btn-third', 'float-right', 'mr-2']"
        [icon]="'far-file-check'"
        [label]="'products.inventories'"
        [title]="'products.inventories' | translate"
        data-cy="inventories"
      ></btn>
      <modal-export-create
        *ngIf="hasRoleExportProductsForMetrics"
        class="float-right mr-2"
        [suppliers]="suppliers"
        [depots]="depots"
        [entity]="'products'"
        data-cy="create-export"
      ></modal-export-create>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters"
      [entity]="'hs-products'"
      [filterVisible]="filterRowsShown"
      [showBulkEditsBtn]="hasRoleProductUpdate"
      [metricsLoading]="metricsLoading"
      (onSubmit)="filter()"
      (onClearClick)="clearFilters()"
      (onExportResult)="filter()"
      (filterVisibleChange)="filterRowsShown = $event; saveViewSettings()"
      [checkedProducts]="checkedProducts"
      [areAllProductsChecked]="areAllProductsChecked"
      [tags]="tags"
      [isInProducts]="true"
      [isExportButtonShown]="true"
      [showEditMetricsBtn]="hasRoleMetricsUpdate"
      (setCheckedProductsToFalse)="setCheckedProductsToFalse()"
      [isEditingMetrics]="isEditingMetrics"
      (editDepotMetrics)="editDepotMetrics()"
      (saveDepotMetrics)="saveDepotMetrics()"
      (cancelEditingMetricsMode)="cancelEditingMetricsMode()"
    >
      <div class="container-fluid pl-0 pr-0">
        <div class="row">
          <div class="col-md-4">
            <form-row-input
              [label]="'products.fulltext'"
              [icon]="null"
              [(model)]="filterFulltext"
              (keyup.enter)="filter()"
              data-cy="product-name-filter"
            ></form-row-input>
          </div>
          <div class="col-md-2">
            <form-row-select-multiple
              [label]="'products.depots'"
              [options]="depots"
              [selectedValues]="filterDepots"
              (selectedValuesChange)="onFilterDepotsChange($event)"
              data-cy="product-depots-filter"
            ></form-row-select-multiple>
          </div>
          <div class="col-md-2">
            <form-row-select
              [label]="'products.availability'"
              [icon]="null"
              [(model)]="selectedAvailability"
              [options]="availabilityTypes"
            ></form-row-select>
          </div>
          <div class="col-md-2">
            <form-row-select
              [label]="'expiration'"
              [icon]="null"
              [model]="selectedExpiration"
              (modelChange)="setExpirationFilter($event)"
              [options]="expirations"
            ></form-row-select>
            <form-row-input
              *ngIf="selectedExpiration === 'custom'"
              [label]="'expiration.date'"
              [icon]="null"
              [inputType]="'date'"
              (modelChange)="setExpirationFilter(null, $event)"
              [ngModel]="!!selectedExpirationDate && selectedExpirationDate.substr(0, 10)"
            ></form-row-input>
          </div>
          <div class="col-md-2">
            <app-modal-category-search
              [isForFilterCategories]="true"
              [selectedCategories]="filterCategories"
              (selectedCategoriesChange)="filterCategoriesChanged($event)"
            >
            </app-modal-category-search>
          </div>
        </div>
        <div class="dropdown" [ngClass]="{ open: filterRowsShown }">
          <div class="row mr-0">
            <div class="col-md-2">
              <form-row-select
                [label]="'product.enabled'"
                [icon]="null"
                [(model)]="filterEnabled"
                [options]="enabledTypes"
              >
              </form-row-select>
            </div>
            <div class="col-md-2">
              <form-row-select
                [label]="'product.under.minimum'"
                [icon]="null"
                [(model)]="filterMetrics"
                [options]="metricsTypes"
              >
              </form-row-select>
            </div>
            <div class="col-md-2">
              <form-row-select
                [label]="'product.filters.automaticOrdering'"
                [icon]="null"
                [(model)]="automaticOrderingType"
                [options]="automaticOrderingTypes"
              >
              </form-row-select>
            </div>
          </div>
        </div>
      </div>
    </app-filter-form>

    <div class="card pt-0 mb-0 padding-0">
      <div
        class="card-body p-0"
        [ngClass]="{
          h150: (!products?.length && loading) || (!loading && (!products || (products && products?.length === 0))),
        }"
      >
        <loading-spinner [isLoading]="reloading" [classesString]="'pt-88'"></loading-spinner>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th colspan="2" class="padding-th-checkbox font-weight-bold grey-th padding-left-td">
                  <form-row-checkbox
                    [isOnProductsPage]="true"
                    *ngIf="!isEditingMetrics"
                    [title]="'select.all' | translate"
                    [model]="areAllProductsChecked"
                    (modelChange)="allProductsChecked($event)"
                  >
                  </form-row-checkbox>
                  <div *ngIf="isEditingMetrics">&nbsp;</div>
                </th>
                <th
                  colspan="3"
                  scope="col"
                  class="cursor-pointer font-weight-bold grey-th padding-top-th"
                  (click)="sortBy('name')"
                  *ngIf="isColumnSelected('name')"
                >
                  {{ 'product.name' | translate }}
                  <i
                    [ngClass]="
                      sortProp !== 'name'
                        ? 'far fa-caret-up'
                        : sortProp === 'name' && sortDir === 'asc'
                          ? 'fas fa-caret-up'
                          : sortProp === 'name' && sortDir === 'desc'
                            ? 'fas fa-caret-down'
                            : ''
                    "
                  ></i>
                </th>
                <th
                  scope="col"
                  class="text-left cursor-pointer text-nowrap d-none d-xl-table-cell font-weight-bold grey-th padding-top-th"
                  (click)="sortBy('ean')"
                  *ngIf="isColumnSelected('mCode')"
                >
                  {{ 'm.code' | translate }}
                  <i
                    [ngClass]="
                      sortProp !== 'ean'
                        ? 'far fa-caret-up'
                        : sortProp === 'ean' && sortDir === 'asc'
                          ? 'fas fa-caret-up'
                          : sortProp === 'ean' && sortDir === 'desc'
                            ? 'fas fa-caret-down'
                            : ''
                    "
                  ></i>
                </th>
                <th
                  scope="col"
                  class="text-left cursor-pointer text-nowrap d-none d-xl-table-cell font-weight-bold grey-th padding-top-th"
                  (click)="sortBy('code2')"
                  *ngIf="isColumnSelected('dlCode')"
                >
                  {{ 'dl.code' | translate }}
                  <i
                    [ngClass]="
                      sortProp !== 'code2'
                        ? 'far fa-caret-up'
                        : sortProp === 'code2' && sortDir === 'asc'
                          ? 'fas fa-caret-up'
                          : sortProp === 'code2' && sortDir === 'desc'
                            ? 'fas fa-caret-down'
                            : ''
                    "
                  ></i>
                </th>
                <th
                  scope="col"
                  class="text-left cursor-pointer text-nowrap d-none d-xl-table-cell font-weight-bold grey-th padding-top-th"
                  (click)="sortBy('code3')"
                  *ngIf="isColumnSelected('producerCode')"
                >
                  {{ 'producer.code' | translate }}
                  <i
                    [ngClass]="
                      sortProp !== 'code3'
                        ? 'far fa-caret-up'
                        : sortProp === 'code3' && sortDir === 'asc'
                          ? 'fas fa-caret-up'
                          : sortProp === 'code3' && sortDir === 'desc'
                            ? 'fas fa-caret-down'
                            : ''
                    "
                  ></i>
                </th>
                <th
                  scope="col"
                  class="fixed-column-width text-nowrap d-none d-xl-table-cell font-weight-bold grey-th padding-top-th"
                  *ngIf="isColumnSelected('quantityStock')"
                >
                  &nbsp;
                </th>
                <th
                  scope="col"
                  class="fixed-column-width text-nowrap d-none d-xl-table-cell font-weight-bold grey-th padding-top-th"
                  *ngIf="isColumnSelected('quantityStock')"
                >
                  {{ 'quantityStock' | translate }}
                </th>
                <th
                  scope="col"
                  class="text-left cursor-pointer text-nowrap d-none d-xl-table-cell padding-right-td padding-top-th"
                >
                  &nbsp;
                </th>
                <th class="fixed-column-width" scope="col">
                  <!--                  [items]="listingColumns | colSettings: selectedColumns"-->
                  <dropdown
                    class="float-right"
                    [icon]="'far-cog'"
                    [items]="selectedColumns"
                    [isArrowHidden]="true"
                    [autoClose]="true"
                    [container]="'.content-wrapper'"
                    (onResult)="onColumnSettingDropdownClick($event)"
                    [isSwitchList]="true"
                    [theme]="'first-only-icon'"
                  ></dropdown>
                </th>
              </tr>
            </thead>

            <tbody *ngIf="!loading && (!products || (products && products.length === 0))">
              <tr>
                <td colspan="13" class="text-center p-5 border-bottom-0 no-hover padding-left-td">
                  <div class="empty-list">
                    <i class="far fa-sad-tear"></i>
                    <div>
                      {{ 'no.record.found' | translate }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>

            <ng-template
              [ngIf]="!reloading && products && products.length > 0"
              class="images"
              [photoGalleryGroup]="{ index: 1 }"
            >
              <ng-container *ngFor="let product of products">
                <tbody
                  [ngClass]="areAllStockRowsVisible || isStockRowRolled(product.id) ? 'rolled-tbody-background' : ''"
                >
                  <tr [ngClass]="{ 'disabled-product': !product.enabled }" class="line-height-3-5">
                    <td colspan="2" class="padding-td-checkbox fixed-column-width">
                      <form-row-checkbox
                        [isOnProductsPage]="true"
                        *ngIf="!isEditingMetrics"
                        [topOnLabel]="true"
                        [model]="isProductRowChecked(product.id)"
                        (modelChange)="productChecked($event, product)"
                        [cursorPointer]="true"
                      >
                      </form-row-checkbox>
                      <div *ngIf="isEditingMetrics">&nbsp;</div>
                    </td>
                    <td class="pl-1" colspan="3" *ngIf="isColumnSelected('name')">
                      <div class="flex-gap-10 align-items-center">
                        <div
                          [photoGallery]="getThumbUrl(product.mainImage, 'w2048wp')"
                          [photoGalleryCaption]="
                            product.name +
                            '<br>' +
                            (product.code ? ('products.code' | translate) + product.code : '') +
                            '<br>' +
                            (product.ean ? ('products.ean' | translate) + product.ean : '')
                          "
                        >
                          <div class="images-item">
                            <img
                              class="images-item-image"
                              [src]="getThumbUrl(product.mainImage)"
                              [alt]="product.name"
                            />
                          </div>
                        </div>
                        <div>
                          <a
                            class="link"
                            [routerLink]="['/product', product.id]"
                            (click)="scrollService.save('selectedItem', product.id)"
                            >{{ product.name }}</a
                          >
                          <div class="product-details flex-gap-5 flex-wrap d-xl-none">
                            <div *ngIf="product.code && product.code.length > 0">
                              {{ 'product.code' | translate }}:<span> {{ product.code }}</span>
                            </div>
                            <div *ngIf="product.ean && product.ean.length > 0">
                              {{ 'product.ean' | translate }}:<span> {{ product.ean }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="text-left d-none d-xl-table-cell text-nowrap" *ngIf="isColumnSelected('mCode')">
                      {{ product.code && product.code.length > 0 ? product.code : '' }}
                    </td>
                    <td class="text-left d-none d-xl-table-cell text-nowrap" *ngIf="isColumnSelected('dlCode')">
                      {{ product.code2 && product.code2.length > 0 ? product.code2 : '' }}
                    </td>
                    <td class="text-left d-none d-xl-table-cell text-nowrap" *ngIf="isColumnSelected('producerCode')">
                      {{ product.code3 && product.code3.length > 0 ? product.code3 : '' }}
                    </td>
                    <td *ngIf="isColumnSelected('quantityStock')">
                      <div class="d-flex">
                        <button
                          *ngIf="isProductQuantityUnderMinimum(product.id)"
                          type="button"
                          class="btn d-flex"
                          [tooltip]="'product.stocks-below-min' | translate"
                          placement="left"
                          containerClass="under-min-icon"
                        >
                          <img src="../../../assets/img/icons/icon-product-under-min.svg" alt="login image" />
                        </button>
                        <button
                          *ngIf="isProductExpired(product)"
                          type="button"
                          class="btn d-flex"
                          [tooltip]="'product.expired' | translate"
                          placement="left"
                          containerClass="expired-icon"
                        >
                          <img src="../../../assets/img/icons/icon-expired-product.svg" alt="login image" />
                        </button>
                      </div>
                    </td>
                    <td class="text-left text-nowrap" *ngIf="isColumnSelected('quantityStock')">
                      <modal-stock-overview
                        [isCalculatedOfProductDepots]="true"
                        [total]="getProductQuantity(product)"
                        [isSumCalculated]="true"
                        [product]="product"
                        [depots]="depots"
                        [suppliers]="suppliers"
                        [filterDepots]="filterDepots"
                        [filterSuppliers]="filterSuppliers"
                        [isQuantityUnderMinimum]="isProductQuantityUnderMinimum(product.id)"
                        [isSomeOfItemsExpired]="isProductExpired(product)"
                      >
                      </modal-stock-overview>
                    </td>
                    <td>&nbsp;</td>
                    <td class="text-left padding-right">
                      <div class="flex-gap-5-reverse align-items-center">
                        <div>
                          <a
                            class="btn-second open-btn-padding"
                            [routerLink]="['/product', product.id]"
                            [title]="'open' | translate"
                            data-cy="open-row"
                            (click)="scrollService.save('selectedItem', product.id)"
                            [id]="product.id"
                          >
                            {{ 'open' | translate }}
                            <i class="far fa-chevron-right align-self-center ml-2"></i>
                          </a>
                        </div>
                        <btn
                          *ngIf="canShowStockBtn(product.id)"
                          [label]="'products.stock'"
                          [title]="'products.stock' | translate"
                          [isBtnInProductsBody]="true"
                          [classes]="['btn-first', 'float-right', 'show-stock-btn']"
                          [icon]="isStockRowRolled(product.id) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
                          (click)="stockRowRolled(product.id)"
                          data-cy="roll-row"
                        ></btn>
                      </div>
                    </td>
                  </tr>

                  <ng-container *ngIf="areAllStockRowsVisible || isStockRowRolled(product.id)">
                    <tr>
                      <td [colSpan]="stockRowColSpan">
                        <div>
                          <ng-container *ngFor="let depot of getDepotsOfProduct(product.id)" class="tbody-background">
                            <ng-container
                              *ngFor="
                                let pDepot of getPDepotsOnDepot(product.id, depot);
                                let first = first;
                                let last = last;
                                let i = index
                              "
                              class="tbody-background"
                            >
                              <tr *ngIf="first">
                                <td colspan="12" class="no-hover no-border">&nbsp;</td>
                              </tr>
                              <tr *ngIf="first">
                                <td class="no-hover no-border">&nbsp;</td>
                                <td class="no-border bg-white border-top-left-radius">&nbsp;</td>
                                <td class="bg-white no-border border-top-right-radius" colspan="9">
                                  <div *ngIf="first" class="flex-gap-1 padding-left-right align-items-center">
                                    <h2
                                      class="mb-0 align-self-center card-title text-nowrap"
                                      [title]="'quantityStock' | translate"
                                    >
                                      {{ depot?.name }}
                                    </h2>
                                    <div class="d-flex text-nowrap align-items-center">
                                      <div
                                        class="depot-quantity-container"
                                        [ngClass]="
                                          isDepotQuantityUnderMinimum(product.id, depot.id)
                                            ? 'yellow-background'
                                            : 'bg-white border-black'
                                        "
                                      >
                                        <div
                                          *ngIf="!isDepotQuantityUnderMinimum(product.id, depot.id)"
                                          class="warehouse-icon p-3"
                                        >
                                          <i class="far fa-warehouse-alt"></i>
                                        </div>
                                        <button
                                          *ngIf="isDepotQuantityUnderMinimum(product.id, depot.id)"
                                          type="button"
                                          class="btn"
                                          tooltip="{{ 'product.stocks-below-min' | translate }}"
                                          placement="left"
                                          containerClass="under-min-icon"
                                        >
                                          <img
                                            src="../../../assets/img/icons/icon-product-under-min.svg"
                                            alt="login image"
                                          />
                                        </button>

                                        <div class="d-flex align-items-center">
                                          <a
                                            class="font-weight-bold"
                                            [ngClass]="
                                              isDepotQuantityUnderMinimum(product.id, depot.id) ? 'yellow' : 'black'
                                            "
                                          >
                                            {{
                                              getDepotQuantityStock(product.id, depot.id) + ' ' + ('piece' | translate)
                                            }}
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <!--                                    todo: celkovy pocet zde qPurchase ( sklad ma konkretni zasoby)-->
                                    <div
                                      class="depot-quantity-container text-nowrap bg-white border-black ml-2 mr-3"
                                      *ngIf="isEditingMetrics && getProductQuantityPurchase(product, depot) > 0"
                                    >
                                      <div class="warehouse-icon">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="22"
                                          height="18"
                                          viewBox="0 0 22 18"
                                          fill="none"
                                        >
                                          <path
                                            d="M21.45 12.9375H20.9V8.85586C20.9 8.18789 20.6353 7.5375 20.1747 7.06641L17.2906 4.1168C16.83 3.6457 16.1906 3.375 15.5409 3.375H14.3V1.96875C14.3 0.882422 13.4372 0 12.375 0H4.125C3.06281 0 2.2 0.882422 2.2 1.96875V3.375H0.275C0.12375 3.375 0 3.50156 0 3.65625V4.21875C0 4.37344 0.12375 4.5 0.275 4.5H8.525C8.67625 4.5 8.8 4.37344 8.8 4.21875V3.65625C8.8 3.50156 8.67625 3.375 8.525 3.375H3.85V1.96875C3.85 1.81406 3.97375 1.6875 4.125 1.6875H12.375C12.5263 1.6875 12.65 1.81406 12.65 1.96875V12.9375H8.34281C7.77219 11.932 6.72031 11.25 5.5 11.25C4.895 11.25 4.33813 11.4293 3.85 11.7176V10.125H2.2V14.625C2.2 16.4883 3.67812 18 5.5 18C7.32188 18 8.8 16.4883 8.8 14.625H13.2C13.2 16.4883 14.6781 18 16.5 18C18.3219 18 19.8 16.4883 19.8 14.625H21.45C21.7525 14.625 22 14.3719 22 14.0625V13.5C22 13.1906 21.7525 12.9375 21.45 12.9375ZM5.5 16.3125C4.58906 16.3125 3.85 15.5566 3.85 14.625C3.85 13.6934 4.58906 12.9375 5.5 12.9375C6.41094 12.9375 7.15 13.6934 7.15 14.625C7.15 15.5566 6.41094 16.3125 5.5 16.3125ZM14.3 5.0625H15.5409C15.7575 5.0625 15.9706 5.15391 16.1253 5.30859L18.6347 7.875H14.3V5.0625ZM16.5 16.3125C15.5891 16.3125 14.85 15.5566 14.85 14.625C14.85 13.6934 15.5891 12.9375 16.5 12.9375C17.4109 12.9375 18.15 13.6934 18.15 14.625C18.15 15.5566 17.4109 16.3125 16.5 16.3125ZM19.25 12.7652C18.6588 11.8547 17.6481 11.25 16.5 11.25C15.6509 11.25 14.8844 11.5875 14.3 12.1254V9.5625H19.25V12.7652ZM8.8 8.71875V8.15625C8.8 8.00156 8.67625 7.875 8.525 7.875H0.275C0.12375 7.875 0 8.00156 0 8.15625V8.71875C0 8.87344 0.12375 9 0.275 9H8.525C8.67625 9 8.8 8.87344 8.8 8.71875ZM9.625 6.75C9.77625 6.75 9.9 6.62344 9.9 6.46875V5.90625C9.9 5.75156 9.77625 5.625 9.625 5.625H1.375C1.22375 5.625 1.1 5.75156 1.1 5.90625V6.46875C1.1 6.62344 1.22375 6.75 1.375 6.75H9.625Z"
                                            fill="#231F20"
                                          />
                                        </svg>
                                      </div>
                                      <div class="d-flex align-items-center">
                                        <div class="font-weight-bold">
                                          {{ getProductQuantityPurchase(product, depot) + ' ' + ('piece' | translate) }}
                                        </div>
                                      </div>
                                    </div>

                                    <div *ngIf="!isEditingMetrics" class="d-flex align-items-center">
                                      <app-modal-product-depot-metric
                                        *ngIf="hasRoleMetricsCreate"
                                        [product]="product"
                                        [depot]="depot"
                                        [isOnProductsPage]="true"
                                      >
                                      </app-modal-product-depot-metric>
                                      <div *ngIf="!hasRoleMetricsCreate">{{ 'product.no-level-set' | translate }}</div>
                                    </div>
                                    <div
                                      class="flex-gap-1 text-nowrap"
                                      *ngIf="isEditingMetrics"
                                      style="min-width: 350px"
                                    >
                                      <form-row-number-with-controls
                                        [label]="'product.quantity.levels.minimal'"
                                        [model]="getQuantityMinimum(product, depot)"
                                        (modelChange)="quantityMinimumChanged($event, product, depot)"
                                        [maxWidthPx]="150"
                                        [noMarginBottom]="true"
                                      >
                                      </form-row-number-with-controls>
                                      <form-row-number-with-controls
                                        [label]="'product.quantity.levels.optimal'"
                                        [model]="getQuantityOptimum(product, depot)"
                                        (modelChange)="quantityOptimumChanged($event, product, depot)"
                                        [maxWidthPx]="150"
                                        [noMarginBottom]="true"
                                      >
                                      </form-row-number-with-controls>
                                    </div>
                                  </div>
                                </td>
                                <td class="width-2 no-hover no-border">&nbsp;</td>
                              </tr>
                              <tr *ngIf="first">
                                <th class="no-hover no-border">&nbsp;</th>
                                <th class="background-white no-hover no-border">&nbsp;</th>
                                <th
                                  class="background-white text-nowrap d-none d-xl-table-cell font-weight-bold grey-thead no-border no-hover"
                                >
                                  {{ 'supplier' | translate }}
                                </th>
                                <th
                                  class="background-white text-nowrap d-none d-xl-table-cell font-weight-bold grey-thead no-border no-hover"
                                >
                                  {{ 'product.batch' | translate }}
                                </th>
                                <th
                                  class="background-white text-nowrap d-none d-xl-table-cell font-weight-bold grey-thead no-border no-hover"
                                >
                                  {{ 'product.expirationDate' | translate }}
                                </th>
                                <th
                                  *ngIf="arePositionsEnabled"
                                  class="background-white text-nowrap d-none d-xl-table-cell font-weight-bold grey-thead no-border no-hover"
                                >
                                  {{ 'position' | translate }}
                                </th>
                                <th
                                  class="background-white text-nowrap d-none d-xl-table-cell font-weight-bold grey-thead no-border no-hover"
                                >
                                  {{ 'purchasePrice' | translate }}
                                </th>
                                <th
                                  class="background-white text-nowrap d-none d-xl-table-cell font-weight-bold grey-thead no-border no-hover"
                                >
                                  <div class="flex-direction-column-gap-20 font-weight-bold">
                                    <div>
                                      {{ 'stock' | translate }}
                                    </div>
                                  </div>
                                </th>
                                <th
                                  class="background-white text-nowrap d-none d-xl-table-cell font-weight-bold grey-thead no-border no-hover"
                                >
                                  &nbsp;
                                </th>
                                <th
                                  class="background-white text-nowrap d-none d-xl-table-cell font-weight-bold grey-thead no-border no-hover"
                                >
                                  &nbsp;
                                </th>
                                <th
                                  class="background-white text-nowrap d-none d-xl-table-cell font-weight-bold grey-thead no-border no-hover"
                                >
                                  {{ 'lastChange' | translate }}
                                </th>
                                <!--                                <th class="background-white text-nowrap d-none d-xl-table-cell no-border no-hover">-->
                                <!--                                  &nbsp;-->
                                <!--                                </th>-->
                                <th class="width-2 no-hover no-border">&nbsp;</th>
                              </tr>

                              <tr
                                [ngClass]="{
                                  'last-line': last,
                                  'first-line': first,
                                  'expired-tr': isProductDepotExpired(pDepot),
                                }"
                                class="line-height-3"
                              >
                                <td class="no-border no-hover">&nbsp;</td>
                                <td [ngClass]="last ? 'border-bottom-left-radius' : ''" class="bg-white no-border">
                                  &nbsp;
                                </td>
                                <td class="bg-white pl-1 text-nowrap fixed no-border td-name">
                                  {{ pDepot?.supplier?.name ? pDepot?.supplier?.name : '--' }}
                                </td>
                                <td class="bg-white text-nowrap fixed no-border">
                                  {{ pDepot.batch ? pDepot.batch : '--' }}
                                </td>
                                <td class="bg-white fixed no-border td-expiration">
                                  <span *ngIf="pDepot.expirationDate">{{
                                    pDepot.expirationDate ? (pDepot.expirationDate | fmtDate: 'dd.MM.yyyy') : '--'
                                  }}</span>
                                </td>
                                <td class="bg-white text-nowrap fixed no-border" *ngIf="arePositionsEnabled">
                                  {{ pDepot.position ? pDepot.position : '--' }}
                                </td>
                                <td class="bg-white d-none d-xl-table-cell text-nowrap fixed no-border">
                                  {{
                                    pDepot.purchasePrice
                                      ? (pDepot.purchasePrice | formatPrice: product.purchaseCurrency)
                                      : '--'
                                  }}
                                </td>
                                <td class="bg-white text-nowrap fixed no-border">
                                  <span>{{
                                    pDepot.quantityStock
                                      ? pDepot.quantityStock + '&nbsp;' + ('piece' | translate)
                                      : '--'
                                  }}</span>
                                </td>
                                <!--                                todo: qPurchase na jednotlivych radcich existing zasob-->
                                <!--                                <td class="bg-white text-nowrap fixed no-border">-->
                                <!--                                  &lt;!&ndash;                                  <div class="depot-quantity-container bg-white border-black" *ngIf="productDepotMetric.quantityPurchase > 0">&ndash;&gt;-->
                                <!--                                  <div-->
                                <!--                                    class="depot-quantity-container bg-white border-black"-->
                                <!--                                    style="max-width: 8rem"-->
                                <!--                                    *ngIf="getProductQuantityPurchase(product, depot) > 0"-->
                                <!--                                  >-->
                                <!--                                    <div class="warehouse-icon">-->
                                <!--                                      <svg-->
                                <!--                                        xmlns="http://www.w3.org/2000/svg"-->
                                <!--                                        width="22"-->
                                <!--                                        height="18"-->
                                <!--                                        viewBox="0 0 22 18"-->
                                <!--                                        fill="none"-->
                                <!--                                      >-->
                                <!--                                        <path-->
                                <!--                                          d="M21.45 12.9375H20.9V8.85586C20.9 8.18789 20.6353 7.5375 20.1747 7.06641L17.2906 4.1168C16.83 3.6457 16.1906 3.375 15.5409 3.375H14.3V1.96875C14.3 0.882422 13.4372 0 12.375 0H4.125C3.06281 0 2.2 0.882422 2.2 1.96875V3.375H0.275C0.12375 3.375 0 3.50156 0 3.65625V4.21875C0 4.37344 0.12375 4.5 0.275 4.5H8.525C8.67625 4.5 8.8 4.37344 8.8 4.21875V3.65625C8.8 3.50156 8.67625 3.375 8.525 3.375H3.85V1.96875C3.85 1.81406 3.97375 1.6875 4.125 1.6875H12.375C12.5263 1.6875 12.65 1.81406 12.65 1.96875V12.9375H8.34281C7.77219 11.932 6.72031 11.25 5.5 11.25C4.895 11.25 4.33813 11.4293 3.85 11.7176V10.125H2.2V14.625C2.2 16.4883 3.67812 18 5.5 18C7.32188 18 8.8 16.4883 8.8 14.625H13.2C13.2 16.4883 14.6781 18 16.5 18C18.3219 18 19.8 16.4883 19.8 14.625H21.45C21.7525 14.625 22 14.3719 22 14.0625V13.5C22 13.1906 21.7525 12.9375 21.45 12.9375ZM5.5 16.3125C4.58906 16.3125 3.85 15.5566 3.85 14.625C3.85 13.6934 4.58906 12.9375 5.5 12.9375C6.41094 12.9375 7.15 13.6934 7.15 14.625C7.15 15.5566 6.41094 16.3125 5.5 16.3125ZM14.3 5.0625H15.5409C15.7575 5.0625 15.9706 5.15391 16.1253 5.30859L18.6347 7.875H14.3V5.0625ZM16.5 16.3125C15.5891 16.3125 14.85 15.5566 14.85 14.625C14.85 13.6934 15.5891 12.9375 16.5 12.9375C17.4109 12.9375 18.15 13.6934 18.15 14.625C18.15 15.5566 17.4109 16.3125 16.5 16.3125ZM19.25 12.7652C18.6588 11.8547 17.6481 11.25 16.5 11.25C15.6509 11.25 14.8844 11.5875 14.3 12.1254V9.5625H19.25V12.7652ZM8.8 8.71875V8.15625C8.8 8.00156 8.67625 7.875 8.525 7.875H0.275C0.12375 7.875 0 8.00156 0 8.15625V8.71875C0 8.87344 0.12375 9 0.275 9H8.525C8.67625 9 8.8 8.87344 8.8 8.71875ZM9.625 6.75C9.77625 6.75 9.9 6.62344 9.9 6.46875V5.90625C9.9 5.75156 9.77625 5.625 9.625 5.625H1.375C1.22375 5.625 1.1 5.75156 1.1 5.90625V6.46875C1.1 6.62344 1.22375 6.75 1.375 6.75H9.625Z"-->
                                <!--                                          fill="#231F20"-->
                                <!--                                        />-->
                                <!--                                      </svg>-->
                                <!--                                    </div>-->

                                <!--                                    <div class="d-flex align-items-center">-->
                                <!--                                      <div class="font-weight-bold">-->
                                <!--                                        {{ getProductQuantityPurchase(product, depot) + ' ' + ('piece' | translate) }}-->
                                <!--                                      </div>-->
                                <!--                                    </div>-->
                                <!--                                  </div>-->
                                <!--                                </td>-->
                                <td class="bg-white text-nowrap fixed no-border">
                                  <button
                                    *ngIf="isProductDepotExpired(pDepot)"
                                    type="button"
                                    class="btn d-flex"
                                    tooltip="{{ 'product.expired' | translate }}"
                                    placement="left"
                                    containerClass="expired-icon"
                                  >
                                    <img src="../../../assets/img/icons/icon-expired-product.svg" alt="login image" />
                                  </button>
                                </td>
                                <td class="bg-white text-left text-nowrap fixed no-border">
                                  {{ pDepot.updated ? (pDepot.updated | date: 'dd.MM.yyyy HH:mm') : '--' }}
                                </td>
                                <!--                                <td class="bg-white no-border">&nbsp;</td>-->
                                <td class="width-2 no-hover no-border">&nbsp;</td>
                              </tr>
                            </ng-container>
                            <ng-container *ngIf="getPDepotsOnDepot(product.id, depot)?.length < 1">
                              <tr>
                                <td colspan="13" class="no-hover no-border p-0">&nbsp;</td>
                              </tr>
                              <tr class="last first">
                                <td class="no-border no-hover">&nbsp;</td>
                                <td class="no-border bg-white border-top-left-radius">&nbsp;</td>
                                <td class="pl-1 bg-white no-border" colspan="3">
                                  <div class="flex-gap-1 padding-left-right align-items-center">
                                    <h2
                                      class="mb-0 align-self-center card-title text-nowrap"
                                      [title]="'quantityStock' | translate"
                                    >
                                      {{ depot?.name }}
                                    </h2>
                                    <div class="d-flex text-nowrap align-items-center">
                                      <div
                                        class="depot-quantity-container"
                                        [ngClass]="
                                          isDepotQuantityUnderMinimum(product.id, depot.id)
                                            ? 'yellow-background'
                                            : 'bg-white border-black'
                                        "
                                      >
                                        <div
                                          *ngIf="!isDepotQuantityUnderMinimum(product.id, depot.id)"
                                          class="warehouse-icon"
                                        >
                                          <i class="far fa-warehouse-alt"></i>
                                        </div>
                                        <button
                                          *ngIf="isDepotQuantityUnderMinimum(product.id, depot.id)"
                                          type="button"
                                          class="btn d-flex"
                                          tooltip="{{ 'product.stocks-below-min' | translate }}"
                                          placement="right"
                                          containerClass="under-min-icon"
                                        >
                                          <img
                                            src="../../../assets/img/icons/icon-product-under-min.svg"
                                            alt="login image"
                                          />
                                        </button>

                                        <div class="d-flex align-items-center">
                                          <a
                                            class="font-weight-bold"
                                            [ngClass]="
                                              isDepotQuantityUnderMinimum(product.id, depot.id) ? 'yellow' : 'black'
                                            "
                                          >
                                            {{
                                              getDepotQuantityStock(product.id, depot.id) + ' ' + ('piece' | translate)
                                            }}
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <!--todo: celkovy pocet qPurchase, kdyz sklad nema konkretni zasoby-->
                                    <div
                                      class="depot-quantity-container text-nowrap bg-white border-black ml-2 mr-3"
                                      *ngIf="isEditingMetrics && getProductQuantityPurchase(product, depot) > 0"
                                    >
                                      <div class="warehouse-icon">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="22"
                                          height="18"
                                          viewBox="0 0 22 18"
                                          fill="none"
                                        >
                                          <path
                                            d="M21.45 12.9375H20.9V8.85586C20.9 8.18789 20.6353 7.5375 20.1747 7.06641L17.2906 4.1168C16.83 3.6457 16.1906 3.375 15.5409 3.375H14.3V1.96875C14.3 0.882422 13.4372 0 12.375 0H4.125C3.06281 0 2.2 0.882422 2.2 1.96875V3.375H0.275C0.12375 3.375 0 3.50156 0 3.65625V4.21875C0 4.37344 0.12375 4.5 0.275 4.5H8.525C8.67625 4.5 8.8 4.37344 8.8 4.21875V3.65625C8.8 3.50156 8.67625 3.375 8.525 3.375H3.85V1.96875C3.85 1.81406 3.97375 1.6875 4.125 1.6875H12.375C12.5263 1.6875 12.65 1.81406 12.65 1.96875V12.9375H8.34281C7.77219 11.932 6.72031 11.25 5.5 11.25C4.895 11.25 4.33813 11.4293 3.85 11.7176V10.125H2.2V14.625C2.2 16.4883 3.67812 18 5.5 18C7.32188 18 8.8 16.4883 8.8 14.625H13.2C13.2 16.4883 14.6781 18 16.5 18C18.3219 18 19.8 16.4883 19.8 14.625H21.45C21.7525 14.625 22 14.3719 22 14.0625V13.5C22 13.1906 21.7525 12.9375 21.45 12.9375ZM5.5 16.3125C4.58906 16.3125 3.85 15.5566 3.85 14.625C3.85 13.6934 4.58906 12.9375 5.5 12.9375C6.41094 12.9375 7.15 13.6934 7.15 14.625C7.15 15.5566 6.41094 16.3125 5.5 16.3125ZM14.3 5.0625H15.5409C15.7575 5.0625 15.9706 5.15391 16.1253 5.30859L18.6347 7.875H14.3V5.0625ZM16.5 16.3125C15.5891 16.3125 14.85 15.5566 14.85 14.625C14.85 13.6934 15.5891 12.9375 16.5 12.9375C17.4109 12.9375 18.15 13.6934 18.15 14.625C18.15 15.5566 17.4109 16.3125 16.5 16.3125ZM19.25 12.7652C18.6588 11.8547 17.6481 11.25 16.5 11.25C15.6509 11.25 14.8844 11.5875 14.3 12.1254V9.5625H19.25V12.7652ZM8.8 8.71875V8.15625C8.8 8.00156 8.67625 7.875 8.525 7.875H0.275C0.12375 7.875 0 8.00156 0 8.15625V8.71875C0 8.87344 0.12375 9 0.275 9H8.525C8.67625 9 8.8 8.87344 8.8 8.71875ZM9.625 6.75C9.77625 6.75 9.9 6.62344 9.9 6.46875V5.90625C9.9 5.75156 9.77625 5.625 9.625 5.625H1.375C1.22375 5.625 1.1 5.75156 1.1 5.90625V6.46875C1.1 6.62344 1.22375 6.75 1.375 6.75H9.625Z"
                                            fill="#231F20"
                                          />
                                        </svg>
                                      </div>
                                      <div class="d-flex align-items-center">
                                        <div class="font-weight-bold">
                                          {{ getProductQuantityPurchase(product, depot) + ' ' + ('piece' | translate) }}
                                        </div>
                                      </div>
                                    </div>

                                    <div *ngIf="!isEditingMetrics" class="d-flex align-items-center">
                                      <app-modal-product-depot-metric
                                        [readonly]="!hasRoleMetricsUpdate || !hasRoleMetricsCreate"
                                        [product]="product"
                                        [depot]="depot"
                                        [isOnProductsPage]="true"
                                      >
                                      </app-modal-product-depot-metric>
                                    </div>
                                    <div
                                      class="flex-gap-1 text-nowrap"
                                      *ngIf="isEditingMetrics"
                                      style="min-width: 350px"
                                    >
                                      <form-row-number-with-controls
                                        [label]="'product.quantity.levels.minimal'"
                                        [model]="getQuantityMinimum(product, depot)"
                                        (modelChange)="quantityMinimumChanged($event, product, depot)"
                                        [maxWidthPx]="150"
                                        [noMarginBottom]="true"
                                      >
                                      </form-row-number-with-controls>
                                      <form-row-number-with-controls
                                        [label]="'product.quantity.levels.optimal'"
                                        [model]="getQuantityOptimum(product, depot)"
                                        (modelChange)="quantityOptimumChanged($event, product, depot)"
                                        [maxWidthPx]="150"
                                        [noMarginBottom]="true"
                                      >
                                      </form-row-number-with-controls>
                                    </div>
                                  </div>
                                </td>
                                <td colspan="6" class="bg-white no-border border-top-right-radius">&nbsp;</td>
                                <td class="no-border no-hover d-flex">&nbsp;</td>
                              </tr>
                              <tr>
                                <td class="no-border no-hover">&nbsp;</td>
                                <td class="padding-td-checkbox bg-white no-border border-top-left-radius">&nbsp;</td>
                                <td class="pl-1 bg-white no-border" colspan="3">
                                  <div class="d-flex grey-text">
                                    <p class="m-0">{{ 'products.no-goods' | translate }}</p>
                                  </div>
                                </td>
                                <td colspan="5" class="text-left d-none d-xl-table-cell text-nowrap bg-white no-border">
                                  <!--todo - chceme opravdu quantityPurchase i na radcich bez zbozi?-->
                                  <!--                                <td-->
                                  <!--                                  [attr.colspan]="arePositionsEnabled ? 3 : 2"-->
                                  <!--                                  class="text-left d-none d-xl-table-cell text-nowrap bg-white no-border"-->
                                  <!--                                >-->
                                  <!--                                  &nbsp;-->
                                  <!--                                </td>-->
                                  <!--                                <td class="bg-white text-nowrap fixed no-border">-->
                                  <!--                                  <div-->
                                  <!--                                    class="depot-quantity-container bg-white border-black"-->
                                  <!--                                    style="max-width: 8rem"-->
                                  <!--                                    *ngIf="getProductQuantityPurchase(product, depot) > 0"-->
                                  <!--                                  >-->
                                  <!--                                    <div class="warehouse-icon">-->
                                  <!--                                      <svg-->
                                  <!--                                        xmlns="http://www.w3.org/2000/svg"-->
                                  <!--                                        width="22"-->
                                  <!--                                        height="18"-->
                                  <!--                                        viewBox="0 0 22 18"-->
                                  <!--                                        fill="none"-->
                                  <!--                                      >-->
                                  <!--                                        <path-->
                                  <!--                                          d="M21.45 12.9375H20.9V8.85586C20.9 8.18789 20.6353 7.5375 20.1747 7.06641L17.2906 4.1168C16.83 3.6457 16.1906 3.375 15.5409 3.375H14.3V1.96875C14.3 0.882422 13.4372 0 12.375 0H4.125C3.06281 0 2.2 0.882422 2.2 1.96875V3.375H0.275C0.12375 3.375 0 3.50156 0 3.65625V4.21875C0 4.37344 0.12375 4.5 0.275 4.5H8.525C8.67625 4.5 8.8 4.37344 8.8 4.21875V3.65625C8.8 3.50156 8.67625 3.375 8.525 3.375H3.85V1.96875C3.85 1.81406 3.97375 1.6875 4.125 1.6875H12.375C12.5263 1.6875 12.65 1.81406 12.65 1.96875V12.9375H8.34281C7.77219 11.932 6.72031 11.25 5.5 11.25C4.895 11.25 4.33813 11.4293 3.85 11.7176V10.125H2.2V14.625C2.2 16.4883 3.67812 18 5.5 18C7.32188 18 8.8 16.4883 8.8 14.625H13.2C13.2 16.4883 14.6781 18 16.5 18C18.3219 18 19.8 16.4883 19.8 14.625H21.45C21.7525 14.625 22 14.3719 22 14.0625V13.5C22 13.1906 21.7525 12.9375 21.45 12.9375ZM5.5 16.3125C4.58906 16.3125 3.85 15.5566 3.85 14.625C3.85 13.6934 4.58906 12.9375 5.5 12.9375C6.41094 12.9375 7.15 13.6934 7.15 14.625C7.15 15.5566 6.41094 16.3125 5.5 16.3125ZM14.3 5.0625H15.5409C15.7575 5.0625 15.9706 5.15391 16.1253 5.30859L18.6347 7.875H14.3V5.0625ZM16.5 16.3125C15.5891 16.3125 14.85 15.5566 14.85 14.625C14.85 13.6934 15.5891 12.9375 16.5 12.9375C17.4109 12.9375 18.15 13.6934 18.15 14.625C18.15 15.5566 17.4109 16.3125 16.5 16.3125ZM19.25 12.7652C18.6588 11.8547 17.6481 11.25 16.5 11.25C15.6509 11.25 14.8844 11.5875 14.3 12.1254V9.5625H19.25V12.7652ZM8.8 8.71875V8.15625C8.8 8.00156 8.67625 7.875 8.525 7.875H0.275C0.12375 7.875 0 8.00156 0 8.15625V8.71875C0 8.87344 0.12375 9 0.275 9H8.525C8.67625 9 8.8 8.87344 8.8 8.71875ZM9.625 6.75C9.77625 6.75 9.9 6.62344 9.9 6.46875V5.90625C9.9 5.75156 9.77625 5.625 9.625 5.625H1.375C1.22375 5.625 1.1 5.75156 1.1 5.90625V6.46875C1.1 6.62344 1.22375 6.75 1.375 6.75H9.625Z"-->
                                  <!--                                          fill="#231F20"-->
                                  <!--                                        />-->
                                  <!--                                      </svg>-->
                                  <!--                                    </div>-->

                                  <!--                                    <div class="d-flex align-items-center">-->
                                  <!--                                      <div class="font-weight-bold">-->
                                  <!--                                        {{ getProductQuantityPurchase(product, depot) + ' ' + ('piece' | translate) }}-->
                                  <!--                                      </div>-->
                                  <!--                                    </div>-->
                                  <!--                                  </div>-->
                                  <!--                                </td>-->
                                </td>

                                <td class="bg-white no-border">&nbsp;</td>
                                <td
                                  class="text-left d-none d-xl-table-cell text-nowrap bg-white no-border border-bottom-right-radius"
                                >
                                  &nbsp;
                                </td>
                                <td class="no-border d-flex bg-white no-border no-hover border-bottom-right-radius">
                                  &nbsp;
                                </td>
                                <td class="no-border no-hover d-flex">&nbsp;</td>
                              </tr>
                            </ng-container>
                          </ng-container>
                          <tr>
                            <td colspan="12" class="no-hover no-border">&nbsp;</td>
                          </tr>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </ng-container>
            </ng-template>
          </table>
          <app-pagination-btn
            *ngIf="(!this.currentPage || this.currentPage <= this.endPage) && this.totalItems > this.products?.length"
            (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
            [currentPage]="currentPage"
            [endPage]="endPage"
            [sortDir]="sortDir"
            [sortProp]="sortProp"
            [loadingPage]="loading"
          >
          </app-pagination-btn>
        </div>
      </div>
    </div>
  </section>
</div>
